import React from 'react'
import styled from '@emotion/styled'
import WarningAmberIcon from '@mui/icons-material/WarningRounded'
import InfoIcon from '@mui/icons-material/InfoRounded'

const colors = {
  warning: '#ffd800',
  info: '#00bbff',
  danger: '#ff0000',
}
const icons = {
  warning: (
    <WarningAmberIcon style={{ color: colors.warning, fontSize: '40px' }} />
  ),
  info: <InfoIcon style={{ color: colors.info, fontSize: '40px' }} />,
  danger: '#ff0000',
}

const DisclaimerContainer = styled('div')(({ theme }) => ({
  backgroundColor: 'transparent',
  justifySelf: 'stretch',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  margin: '1rem 2rem',
  color: theme.palette.text.secondary,
  '&>:first-of-type': {
    marginLeft: '0px',
  },
  '&>:last-child': {
    marginRight: '0px',
  },
  width: '-webkit-fill-available',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    margin: '1rem 1rem',
    justifyContent: 'center',
  },
}))

const DisclaimerCard = styled('div')(({ theme, main }) => ({
  flex: 1,
  backgroundColor: '#FFF',
  borderBottomColor: main
    ? theme.palette.secondary.main
    : theme.palette.text.primary,
  borderBottomWidth: '1rem',
  borderBottomStyle: 'solid',
  justifySelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '5px',
  paddingTop: '2rem',
  margin: '0 1rem',
  color: theme.palette.text.primary,
  boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    margin: '1rem 0',
  },
}))

const CardText = styled('Typography')(({ theme, main }) => ({
  color: main ? theme.palette.secondary.main : theme.palette.text.primary,
  width: '100%',
  fontSize: '1rem',
  fontWeight: '400',
  marginBottom: '2rem',
  marginTop: '2rem',
  paddingRight: '2rem',
  paddingLeft: '2rem',
  textAlign: 'center',
  flex: 1,
}))

function ServiceDisclaimer(props) {
  return (
    <DisclaimerContainer>
      <DisclaimerCard color="secondary">
        {/* <PriceCardTitle main>{title1}</PriceCardTitle> */}
        {icons.warning}
        <CardText main>{props.message}</CardText>
        {props.disclaimerMessage && (
          <CardText main>
            In order for CST Flight Services to correctly make payments to the
            Mexican Government on your behalf for unpaid Mexican airspace fees,
            we will need a copy of the permanent Registration Certificate for
            the aircraft and the Mexican User Number assigned to you for
            airspace fees. If you do not have a Mexican User Number, or you do
            not know what it is, then we will need a Limited Power Of Attorney
            (POA) to act on your behalf to obtain it. The Mexican authorities
            will <b>NOT SHARE</b> your User Number nor flight details with us
            unless we have the POA. Making payments to the Mexican government on
            your behalf without the correct User Number does not guarantee that
            the payments will be credited to your flight(s) which could result
            in denial of entry into Mexican Airspace or being detained on the
            ground on a flight to Mexico with the corresponding business
            disruption, time and costs lost.
          </CardText>
        )}
        <a
          href="https://standalone-qa-pdf-files.s3.us-east-1.amazonaws.com/MX_AIRSPACE/SPECIAL+LIMITED+POWER+OF+ATTORNEY+JAN-2026.doc"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download the Limited Power Of Attorney
        </a>
      </DisclaimerCard>
    </DisclaimerContainer>
  )
}

export default ServiceDisclaimer
